'use strict';

angular.module('vendor')
.service("RebateService", function($resource, appConfig) {
    var rebateTypesResource = $resource(appConfig.API_SERVER + '/catalog/vendor/rebate/rebate-types/');
    var rebateResource = $resource(appConfig.API_SERVER + '/catalog/vendor/rebate/:id/', {
        id: '@id'
    }, {
        delete: {
            method: 'DELETE'
        }
    });

    this.queryRebateTypes = function() {
        return rebateTypesResource.query();
    };

    this.delete = function(rebate) {
        return rebateResource.delete({
            id: rebate.id
        });
    }
});



//////////////////
// WEBPACK FOOTER
// ./vendor/sections/catalog/catalog-entry-tab/catalog-entry-rebate/rebate.service.js
// module id = 882
// module chunks = 0